import { Injectable } from '@angular/core';
import { firstValueFrom, forkJoin, map } from 'rxjs';
import { RadioModel } from '../../../personal-data/model/radio.model';
import { DomainDataService } from './domain-data.service';
import { DomainUtil } from './domain-util';
import { DomainDataType } from './model/domain-data-type';
import { DomainOrigin } from "./model/domain-origin";
import { ContaIonService } from './services/conta-ion.service';


@Injectable({
  providedIn: 'root'
})
export class ContaIonCaronteService implements DomainDataService {
  private readonly dominios = {
		[DomainDataType.DocumentType]: { id_dominio: '19' }, 
		[DomainDataType.Gender]: { id_dominio: '29' },
		[DomainDataType.DocumentIssuing]: { id_dominio: '13' },
		[DomainDataType.MaritalStatus]: { id_dominio: '23' },
		[DomainDataType.OriginIncome]: { id_dominio: '469' },
		[DomainDataType.Profession]: { id_dominio: '28' },
		[DomainDataType.Nationality]: { id_dominio: '24' }
	};
  
  constructor(private service: ContaIonService) { }


  async getDomains(domainType: DomainDataType | DomainDataType[], parameter?: any): Promise<RadioModel[]> {
    if (Array.isArray(domainType)) {

      const response = await firstValueFrom(this.load(domainType, parameter)) as RadioModel[];
  
      const validIds = domainType
        .map(type => this.dominios[type]?.id_dominio)
        .filter(Boolean)
        .map(String);
  
      const groupedByDomain: { [key: string]: RadioModel[] } = {};
  
      response.forEach(item => {
        const id = String(item.dominioId);
        if (validIds.includes(id)) {
          if (!groupedByDomain[id]) groupedByDomain[id] = [];
          groupedByDomain[id].push(item);
        }
      });
  
      domainType.forEach(type => {
        const id = String(this.dominios[type]?.id_dominio);
        if (groupedByDomain[id]) {
          DomainUtil.saveDomainInCache(this.getOrigin(), type, groupedByDomain[id], parameter);
        }
      });
  
      return response;
    } else {
      const dataCache = DomainUtil.getDomainFromCache(this.getOrigin(), domainType, parameter);

      if (dataCache && dataCache.length > 0) {
        return Promise.resolve(dataCache);
      }
        return new Promise((resolve, reject) => {
          this.load(domainType, parameter)
            .subscribe((data: any) => {
              console.warn('[ContaIonCaronteService] SALVA DOMINIO NA MEMÓRIA', this.getOrigin(), domainType, data, parameter);
              DomainUtil.saveDomainInCache(this.getOrigin(), domainType, data, parameter);
              resolve(data);
            }, reject);
        });
    }
  }

  getOrigin(): DomainOrigin {
    return DomainOrigin.CaronteContaIon;
  }


  private load(domainType:  DomainDataType | DomainDataType[], parameter?: any): any {

    switch (domainType) {
      case DomainDataType.City:
      case DomainDataType.State:
      case DomainDataType.CountryNif:
        return this.service.getRootDomains(domainType, parameter);
      case DomainDataType.Country:
        return this.service.getCountry();
      default:
        return this.service.getQADomain(domainType);
    }
  }
}
